export function textShorter(string, count) {
    var trimmedString = string.substr(0, count);
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))

    return trimmedString;
}

